// Basic
import PropTypes from 'prop-types';
// Components
import TooltipHelper from '@/common-utils/components/renders/tooltip/TooltipHelper';
import Icon from '@/common-utils/components/renders/icon/Icon';
import Entity from '@/common-utils/components/renders/entity/Entity';
// Common
import ICONS from '@/common-utils/enums/icons';
// Lang
import { nsPlan } from '@/app/i18n/namespaces';

/**
 * @param root0
 * @param root0.plan
 * @returns {JSX} RenderPlanLabel
 */
function RenderPlanLabel({ plan }) {
    return (
        <TooltipHelper
            trigger={
                <div className='flex flex-col max-w-48 gap-1'>
                    <Entity entity={plan?.label} className='text-left whitespace-nowrap text-ellipsis overflow-hidden' />
                    {
                        plan?.shouldAutoActivateSubscriptions ?
                            <div className='text-xs flex text-success items-left'>
                                <Icon icon={ICONS.DEFAULT_PLAN} />
                                <Entity
                                    entity='keys.auto_activate_short'
                                    namespace={nsPlan}
                                    className='text-success'
                                />
                            </div>
                            :
                            false
                    }
                </div>
            }
            content={
                <div>
                    {plan?.label}
                </div>
            }
        />
    );
}

RenderPlanLabel.propTypes = {
    plan: PropTypes.object.isRequired
};

export default RenderPlanLabel;